/* Schema for layout
 {
    layout: null,
    isError: false,
    isFetching: false
}; */

export const initialState = {
    layouts: {},
    page: ''
};

export const FINANCE_LAYOUT_IDENTIFIER = 'FINANCE_LAYOUT';

export const FINANCE_ACTIONS = {
    REQUEST: `REQUEST_${FINANCE_LAYOUT_IDENTIFIER}`,
    RECEIVE: `RECEIVE_${FINANCE_LAYOUT_IDENTIFIER}`,
    ERROR: `ERROR_${FINANCE_LAYOUT_IDENTIFIER}`,
    SET_PAGE: `SET_PAGE_${FINANCE_LAYOUT_IDENTIFIER}`
};

const changeStatus = (status, key) => {
    return {
        [key]: status
    };
};

const changeIsFetchingStatus = status => changeStatus(status, 'isFetching');
const changeIsErrorStatus = status => changeStatus(status, 'isError');

const getNewLayouts = (state, action) => {
    if (!action.data) {
        return state.layout;
    }
    const newLayout = action.data?.data;

    return { ...newLayout };
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case FINANCE_ACTIONS.SET_PAGE:
            return {
                ...state,
                ... { page: action.data }
            };
        case FINANCE_ACTIONS.REQUEST:
            return {
                ...state,
                ...{
                    layouts: {
                        [state.page]: {
                            ...changeIsFetchingStatus(true),
                            ...changeIsErrorStatus(false)
                        }
                    }
                }
            };
        case FINANCE_ACTIONS.RECEIVE:
            return {
                ...state,
                ...{
                    layouts: {
                        [state.page]: {
                            layout: getNewLayouts(state, action),
                            ...changeIsFetchingStatus(false),
                            ...changeIsErrorStatus(false)
                        }

                    }
                }
            };
        case FINANCE_ACTIONS.ERROR:
            return {
                ...state,
                ...{
                    layouts: {
                        [state.page]: {
                            ...changeIsFetchingStatus(false),
                            ...changeIsErrorStatus(true)
                        }

                    }
                }
            };
        default:
            return state;
    }
};
